/* eslint-disable import/prefer-default-export,react/forbid-prop-types */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { isMobile } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import { CardLogo } from '../CardLogo';
import { PendingCardInfoPopup } from '../PendingCardInfoPopup';
import { dynamicAssets } from '../../../../utilities/helpers';

export const PendingCard = ({ cardProvider, cardNetwork, togglePendingCardInfo }) => {
  const { t: translate } = useTranslation();
  const [pendingCardInfoPopupShow, setPendingCardInfoPopupShow] = useState(false);

  return (
    <div className="position-relative">
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 370 218"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <rect width="370" height="218" rx="12" fill="black" />
        <rect
          opacity="0.6"
          x="0.5"
          y="0.5"
          width="369"
          height="217"
          rx="11.5"
          fill="url(#paint0_linear_19084_153888)"
          stroke="url(#paint1_linear_19084_153888)"
        />
        <CardLogo cardNetwork={cardNetwork?.toUpperCase()} cardProvider={cardProvider} />
        <g>
          <text fill="white" fontWeight="bold" fontSize="12" x="20" y="40">
            {translate('card_being_created_label')}
          </text>

          <g
            onMouseEnter={!isMobile ? () => setPendingCardInfoPopupShow(true) : () => {}}
            onMouseLeave={!isMobile ? () => setPendingCardInfoPopupShow(false) : () => {}}
            onClick={isMobile ? togglePendingCardInfo : () => {}}>
            <image
              role="img"
              alt="info"
              className="cursor-pointer"
              xlinkHref={dynamicAssets('./assets/icons/info.svg')}
              x="185"
              y="28"
              width="15"
              height="15"
            />
          </g>
        </g>
        <defs>
          <linearGradient
            id="paint0_linear_19084_153888"
            x1="370"
            y1="0.24809"
            x2="292.961"
            y2="280.088"
            gradientUnits="userSpaceOnUse">
            <stop stopColor="white" stopOpacity="0.5" />
            <stop offset="0.390033" stopColor="white" stopOpacity="0.33" />
            <stop offset="1" stopColor="white" stopOpacity="0" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_19084_153888"
            x1="-7.18182e-07"
            y1="100"
            x2="370"
            y2="102.5"
            gradientUnits="userSpaceOnUse">
            <stop stopOpacity="0.6" />
            <stop offset="1" stopColor="white" stopOpacity="0.6" />
          </linearGradient>
          <clipPath id="clip0_19084_153888">
            <rect width="51.5487" height="40" fill="white" transform="translate(302.451 162)" />
          </clipPath>
          <clipPath id="clip1_19084_153888">
            <rect width="51.5487" height="40" fill="white" transform="translate(302.451 162)" />
          </clipPath>
        </defs>
      </svg>
      {pendingCardInfoPopupShow && (
        <PendingCardInfoPopup label={translate('pending_card_info_note')} />
      )}
    </div>
  );
};

PendingCard.propTypes = {
  cardProvider: PropTypes.string,
  cardNetwork: PropTypes.string,
  togglePendingCardInfo: PropTypes.func,
};

PendingCard.defaultProps = {
  cardProvider: null,
  cardNetwork: '',
  togglePendingCardInfo: () => {},
};
